"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RESERVED_COLUMNS = exports.VALID_FIELD_NAME_PATTERN = exports.LOGIC_OPERATORS = exports.COLUMN_FILTER_OPERATORS = exports.SortDirection = exports.FieldType = void 0;
var FieldType;
(function (FieldType) {
    FieldType["String"] = "string";
    FieldType["Boolean"] = "boolean";
    FieldType["Number"] = "number";
    FieldType["Date"] = "date";
    FieldType["Relation"] = "relation";
    FieldType["Custom"] = "custom";
})(FieldType || (exports.FieldType = FieldType = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
})(SortDirection || (exports.SortDirection = SortDirection = {}));
exports.COLUMN_FILTER_OPERATORS = [
    'contains',
    'doesNotContain',
    'equals',
    'doesNotEqual',
    'startsWith',
    'endsWith',
    'isEmpty',
    'isNotEmpty',
    'is',
    'not',
    'isAnyOf',
    'isNoneOf',
    'greaterThan',
    'greaterThanOrEqual',
    'lessThan',
    'lessThanOrEqual',
];
exports.LOGIC_OPERATORS = {
    AND: 'and',
    OR: 'or',
};
exports.VALID_FIELD_NAME_PATTERN = /^[a-zA-Z_][a-zA-Z0-9_]*$/;
exports.DEFAULT_RESERVED_COLUMNS = ['projectId', 'buildId', 'ownerId', 'userId', 'organizationId'];
//# sourceMappingURL=types.js.map